import React from 'react';
import IconPlane from '@lt/components/icons-react/userflow/Plane';
import { formatDistance } from '@lt/components/utils/userflow';
import HotelFeature from '../HotelFeature';

import styles from './airportDistanceFeature.module.css';

type AirportDistanceFeatureProps = {
  value: number | null;
  isMobile: boolean;
};

const AirportDistanceFeature: React.FC<AirportDistanceFeatureProps> = ({
  value,
  isMobile,
}) =>
  value ? (
    <HotelFeature
      Label={formatDistance(value)}
      Icon={<IconPlane className={styles.iconPlane} />}
      isMobile={isMobile}
    />
  ) : null;

export default AirportDistanceFeature;
